import { addDays, DisplayDate } from 'owa-datetime';

/**
 * Get an array of successive DisplayDates, starting with the given date.
 */
export default function getSuccessiveDisplayDates(date: DisplayDate, count: number): DisplayDate[] {
    let result: DisplayDate[] = [];

    for (let i = 0; i < count; i++) {
        result.push(date);
        date = addDays(date, 1);
    }

    return result;
}
